<div
  class="dropdown"
  [class.open]="isOpen()">
  @if (label) {
    <label class="dropdown__label">
      {{ label }}
    </label>
  }
  <div
    class="dropdown__selected"
    (click)="toggle()">
    {{ selectedLabel() }}
  </div>

  @if (isOpen()) {
    <ul class="dropdown__list">
      @for (option of options; track option.value) {
        <li
          (click)="select(option)"
          class="dropdown__element"
          [class.active]="isSelected(option)">
          {{ option.label }}
        </li>
      }
    </ul>
  }
</div>
